'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofCatalog = require('../dof-catalog');

var _dofCatalog2 = _interopRequireDefault(_dofCatalog);

var _dofRadio = require('../dof-radio');

var _dofRadio2 = _interopRequireDefault(_dofRadio);

var _optionListCircle = require('./option-list-circle.vue');

var _optionListCircle2 = _interopRequireDefault(_optionListCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { DofRadio: _dofRadio2.default, OptionListCircle: _optionListCircle2.default, DofCatalog: _dofCatalog2.default },
  mixins: [],
  props: {
    title: {
      type: String,
      default: '重复周期'
    },
    repeatType: {
      type: String,
      default: '1'
    },
    selectedDays: {
      type: String,
      default: '1E2E370'
    }
  },
  data: function data() {
    return {
      cols: 7,
      customStyles: {
        width: '58px',
        height: '58px',
        borderRadius: '58px',
        marginRight: '46px',
        paddingTop: '300px',
        backgroundColor: '#C7C7CC',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      currentSelectedType: this.repeatType,
      repeatList: [{ title: '执行一次', value: 0, data: '1E2E370', checked: false }, { title: '每天', value: 1, data: '1111111', checked: false }, { title: '工作日', value: 2, data: '1111100', checked: false }, { title: '周末', value: 3, data: '0000011', checked: false }, { title: '自定义', value: 4, data: '-1', checked: false }],
      dayList: [{ title: '一', value: 1, checked: false }, { title: '二', value: 2, checked: false }, { title: '三', value: 3, checked: false }, { title: '四', value: 4, checked: false }, { title: '五', value: 5, checked: false }, { title: '六', value: 6, checked: false }, { title: '日', value: 7, checked: false }],
      checkedList: []
    };
  },

  computed: {
    isDyMode: function isDyMode() {
      return this.currentSelectedType == '4';
    }
  },
  methods: {
    repeatSelect: function repeatSelect(e) {
      var repeatType = this.repeatType;

      this.currentSelectedType = e.value;
      this.$emit('onRepeatSelect', { value: e.value });
    },
    dayChange: function dayChange(e) {
      this.checkedList = e.checkedList;
      this.$emit('onDayChange', { value: this.checkedList });
    },
    init: function init() {
      var repeatType = this.repeatType,
          selectedDays = this.selectedDays;

      repeatType && (this.currentSelectedType = repeatType);
      // const currentDayList = selectedDays.split('').reverse()   // why do this? add by haironglau
      var currentDayList = selectedDays.split('');
      var isFindItem = false;
      this.repeatList.forEach(function (item) {
        if (item.value == repeatType) {
          item.checked = true;
          isFindItem = true;
        } else {
          item.checked = false;
        }
      });
      if (!isFindItem) {
        // this.repeatList[3].checked = true
        this.currentSelectedType = '4';
      }
      this.dayList.forEach(function (item, idx) {
        if (currentDayList[idx] == 1) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
    }
  },
  watch: {
    repeatType: {
      handler: function handler(newVal) {
        // this.$MID.alert(newVal)
        newVal && this.init();
      },

      immediate: true
    },
    selectedDays: {
      handler: function handler(newVal) {}
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-date-cycle-picker/index.vue
// module id = 324
// module chunks = 0 1